import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().min(1, { message: "username_no_empty_femsg" }),
  password: z.string().min(1, { message: "password_no_empty_femsg" }),
});

export type LoginSchema = z.infer<typeof loginSchema>;
